import { useCallback, useState } from 'react';
import { Button, CopyButtonWithTooltip } from '@tryhackme/thm-ui-components';
import { useExpiredVmTime, useExtendVmTime, useStartTimeVm } from 'src/common/hooks';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { setActiveMachine } from 'src/app/reducers/room/room.reducer';
import { MachineExpiringWrapper } from '../machine-expiring';
import { StyledSectionTitle, StyledMachineContent, StyledInfoTitle, StyledContent, StyledButtonsWrapper, StyledInfoValueWithCopyButton } from './active-machine-info.styles';
import { ActiveMachineProps } from './active-machine-info.types';
import { ModalActiveMachineInfo, TerminateMachineModal } from './components';
import { ExpiredMachineModal } from './components/expired-machine-modal';
export const ActiveMachineInfo = ({
  remAttackBoxBtn,
  activeMachine,
  roomCode
}: ActiveMachineProps) => {
  const dispatch = useAppDispatch();
  const [isOpenTerminateMachineModal, setIsOpenTerminateMachineModal] = useState(false);
  const [openExpiredMachineModal, setOpenExpiredMachineModal] = useState<boolean>(false);
  const {
    formattedStartTimeLeft,
    hideIpAddress
  } = useStartTimeVm(activeMachine);
  const onExpireActiveMachine = useCallback(() => {
    dispatch(setActiveMachine());
  }, [dispatch]);
  const {
    handleExtendVmTime,
    isLoading: isExtendVmTimeLoading
  } = useExtendVmTime();
  const {
    formattedTime
  } = useExpiredVmTime(activeMachine.expires, setOpenExpiredMachineModal);
  const {
    vmPanelOpen
  } = useAppSelector(state => state.splitScreen);
  const instanceId = activeMachine.id;
  const activeMachineIPValue = hideIpAddress ? `Shown in ${formattedStartTimeLeft}` : `${activeMachine.internalIP ?? ''}`;
  return <>
      <ExpiredMachineModal open={openExpiredMachineModal} onOpenChange={setOpenExpiredMachineModal} onCloseCallback={onExpireActiveMachine} data-sentry-element="ExpiredMachineModal" data-sentry-source-file="active-machine-info.tsx" />

      <MachineExpiringWrapper activeMachine={activeMachine} data-sentry-element="MachineExpiringWrapper" data-sentry-source-file="active-machine-info.tsx" />

      <StyledSectionTitle data-sentry-element="StyledSectionTitle" data-sentry-source-file="active-machine-info.tsx">
        <p>Target Machine Information</p>
      </StyledSectionTitle>

      <StyledMachineContent id="active-machine-info" $vmPanelOpen={vmPanelOpen} data-testid="active-machine-info" data-sentry-element="StyledMachineContent" data-sentry-source-file="active-machine-info.tsx">
        <StyledContent $vmPanelOpen={vmPanelOpen} data-sentry-element="StyledContent" data-sentry-source-file="active-machine-info.tsx">
          <div>
            <StyledInfoTitle data-sentry-element="StyledInfoTitle" data-sentry-source-file="active-machine-info.tsx">Title</StyledInfoTitle>
            <p>{activeMachine.title}</p>
          </div>
          <div>
            <StyledInfoTitle data-sentry-element="StyledInfoTitle" data-sentry-source-file="active-machine-info.tsx">Target IP Address</StyledInfoTitle>
            <StyledInfoValueWithCopyButton data-testid="ip-address" data-sentry-element="StyledInfoValueWithCopyButton" data-sentry-source-file="active-machine-info.tsx">
              <p>{activeMachineIPValue}</p>
              <CopyButtonWithTooltip value={activeMachineIPValue} data-sentry-element="CopyButtonWithTooltip" data-sentry-source-file="active-machine-info.tsx" />
            </StyledInfoValueWithCopyButton>
          </div>
          <div>
            <StyledInfoTitle data-sentry-element="StyledInfoTitle" data-sentry-source-file="active-machine-info.tsx">Expires</StyledInfoTitle>
            <p>{formattedTime}</p>
          </div>
        </StyledContent>
        <StyledButtonsWrapper $vmPanelOpen={vmPanelOpen} data-sentry-element="StyledButtonsWrapper" data-sentry-source-file="active-machine-info.tsx">
          {!remAttackBoxBtn && <ModalActiveMachineInfo roomCode={roomCode} />}
          <Button variant="outlined" color="secondary" isLoading={isExtendVmTimeLoading} onClick={() => {
          handleExtendVmTime(instanceId).catch(() => {});
        }} data-sentry-element="Button" data-sentry-source-file="active-machine-info.tsx">
            Add 1 hour
          </Button>
          <Button variant="solid" color="error" onClick={() => setIsOpenTerminateMachineModal(true)} data-sentry-element="Button" data-sentry-source-file="active-machine-info.tsx">
            Terminate
          </Button>
        </StyledButtonsWrapper>
      </StyledMachineContent>

      <TerminateMachineModal runningInstance={activeMachine} open={isOpenTerminateMachineModal} onOpenChange={setIsOpenTerminateMachineModal} data-sentry-element="TerminateMachineModal" data-sentry-source-file="active-machine-info.tsx" />
    </>;
};